import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  has(key: string) {
    return !!this.get(key);
  }

  get<T = object>(key: string): T {
    const serialised = sessionStorage.getItem(key);
    if (serialised === "undefined") {
      return null;
    }
    return <T>JSON.parse(serialised);
  }

  set(key: string, value: object) {
    const serialised = JSON.stringify(value);

    sessionStorage.setItem(key, serialised);
  }

  delete(key: string) {
    sessionStorage.removeItem(key);
  }

}
